(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HomeController', HomeController);

/* Added 'ProfileService', 'HomeTest'
    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
*/
    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'ProfileService', 'HomeTest'];
    
    function HomeController ($scope, Principal, LoginService, $state, ProfileService, HomeTest) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        vm.firmProfile = 'default';
        
        vm.testResult = 'unk';
        HomeTest.get({},testOk,testFail);
        function testOk() {
        	vm.testResult = 'ok';
        }
        function testFail(res) {
            if (res.status === 0 || res.status === -1) {
                vm.testResult = 'fail';
            } else if (res.status === 502) {
                vm.testResult = 'offline';
            }
            
        }
        
        
        ProfileService.getProfileInfo().then(function(response) {
            if (response.kayanProfile) {
                vm.firmProfile = 'kayan';
            }
        });
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();
